//#region [IMPORT]
import { useEffect, useState } from 'react';
import { on, onTask, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export const useTaskStatus = () => {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const [ has_task, setHasTask ] = useState(false);
  const [    views, setViews   ] = useState( {}  );
  const [       id, setId      ] = useState( null);

  //#endregion

  //#region [EFFECT]

  //-----------------------------------------------------------------
  async function handleTask(data) {
    //-----------------------------------------------------------------
    setId( data?.id );
    const result = data?.id ? true : false;
    setHasTask(result);
    setViews( data?.views );
  }

  useEffect( () => {

    on( 'TASK_INFO', handleTask );
    
    return () => {
      removeListener( 'TASK_INFO' , handleTask );
    };

  }, [] );

  //#endregion

  return {id, has_task, views};
}